import { UserRequirementsActionsEnum } from '../enums/UserRequirementsActionsEnum';
import { IUserRequirementsState } from '../interfaces/IUserRequirementsState';
import { UserRequirementsAction } from '../types/UserRequirementsAction';

const initial: IUserRequirementsState = {
  templatesList: [],
  page: 0,
  pageCount: 0,
  totalCount: 0,
  order: '',
};

export function userRequirementsReducer(state = initial, action: UserRequirementsAction) {
  switch (action.type) {
    case UserRequirementsActionsEnum.USER_REQUIREMENTS_RESET_PAGE: {
      return initial;
    }
    case UserRequirementsActionsEnum.USER_REQUIREMENTS_SET_TEMPLATE_LIST: {
      const { templatesList, page, totalCount, pageCount } = action.payload;
      const newState: IUserRequirementsState = {
        ...state,
        templatesList,
        page,
        pageCount,
        totalCount,
      };

      return newState;
    }
    case UserRequirementsActionsEnum.USER_REQUIREMENTS_SET_ACTIVE_TEMPLATE_ID: {
      const newState: IUserRequirementsState = {
        ...state,
        activeTemplateId: action.payload.id,
      };

      return newState;
    }
    default:
      return state;
  }
}
